module.exports = __webpack_public_path__ + "img/network.d98c5cb6.png";